<template>
  <div class="fotersa">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="客户姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                v-model="custName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="权益名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                :allowClear="true"
                v-model="equityName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="height: 41px; line-height: 41px">
              <a-button class="btone" @click="searchList(1)">查询</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <a-table
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :data-source="tableData"
        :pagination="false"
        bordered
        size="small"
        :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
      >
        <div slot="index" slot-scope="text, record, index">
          {{ index + (pageNum - 1) * pageSize + 1 }}
        </div>
        <span slot="reviewStatus" slot-scope="text, record">
          <span v-if="record.reviewStatus == 2"><a-badge color="cyan" /></span>
          <span v-else-if="record.reviewStatus == 1"
            ><a-badge color="orange"
          /></span>
          <span v-else-if="record.reviewStatus == 3"
            ><a-badge color="red"
          /></span>
          <span v-else-if="record.reviewStatus == 4"
            ><a-badge color="orange"
          /></span>
          {{ record.reviewStatus | DictionaryFilter("REFUND_APPLY_STATUS") }}
        </span>
        <span slot="refundStatus" slot-scope="text, record">
          <span v-if="record.refundStatus == 2"><a-badge color="cyan" /></span>
          <span v-else-if="record.refundStatus == 1"
            ><a-badge color="orange"
          /></span>
          {{ record.refundStatus | DictionaryFilter("REFUND_STATUS") }}
        </span>
        <span slot="comments" slot-scope="text, record">
          <span v-if="record.reviewStatus == 3" style="color: red">{{
            text
          }}</span>
          <span v-else> {{ text }}</span>
        </span>

        <!-- 操作 -->
        <template slot="operation" slot-scope="text, record">
          <!--  -->
          <a-button
            href="javascript:;"
            @click="addinput(record)"
            class="btaction"
            >详情</a-button
          >
        </template>
      </a-table>

      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>

      <!-- 审核 -->
      <a-modal
        v-model="visible"
        on-ok="handleOk"
        width="1100px"
        :destroyOnClose="true"
        :maskClosable="false"
        v-if="visible"
        @cancel="handleCancel"
      >
        <div slot="title" class="tip-icon">{{ Title }}</div>
        <template slot="footer">
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="handleOk"
            :disabled="disabled"
          >
            确认
          </a-button>
        </template>
        <div class="add-mess">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            class="input-input"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="accountName"
                  label="账户姓名"
                  prop="accountName"
                >
                  <a-input disabled v-model="form.accountName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  ref="accountNo"
                  label="账户编号"
                  prop="accountNo"
                >
                  <a-input v-model="form.accountNo" disabled />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="applyAmount"
                  label="申请金额"
                  prop="applyAmount"
                >
                  <a-input disabled v-model="form.applyAmount" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  ref="actualRefundAmount"
                  label="实退金额"
                  prop="actualRefundAmount"
                >
                  <a-input v-model="form.actualRefundAmount" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="reviewStatus"
                  label="审核结果"
                  prop="reviewStatus"
                >
                  <a-radio-group v-model="form.reviewStatus">
                    <a-radio value="2"> 同意 </a-radio>
                    <a-radio value="3"> 拒绝 </a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  ref="comments"
                  label="审核意见"
                  prop="comments"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 20 }"
                >
                  <a-input
                    v-model="form.comments"
                    placeholder="审核意见"
                    type="textarea"
                    style="height: 80px"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </a-modal>

      <!-- 新增 -->
      <a-modal
        v-model="addvisible"
        on-ok="handleOk"
        width="1000px"
        :destroyOnClose="true"
        :maskClosable="false"
        v-if="addvisible"
        @cancel="handleCancel"
      >
        <div slot="title" class="tip-icon">退费申请新增</div>
        <template slot="footer">
          <a-button
            key="submit"
            class="btaction"
            :loading="loading"
            @click="addhandleOk"
            :disabled="disabled"
          >
            确认
          </a-button>
        </template>

        <div class="add-mess">
          <a-form-model
            ref="addruleForm"
            :model="addform"
            :rules="addrules"
            class="input-input"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="accountName"
                  label="账户姓名"
                  prop="accountName"
                >
                  <a-input
                    :disabled="disabled"
                    style="width: 318px"
                    @click="addinput"
                    v-model="addform.accountName"
                    placeholder="请输入账户姓名"
                  />
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item
                  ref="accountAmount"
                  label="账户余额"
                  prop="accountAmount"
                >
                  <a-input
                    :disabled="true"
                    style="width: 350px"
                    suffix="元"
                    v-model="addform.accountAmount"
                    placeholder="请输入账户余额"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="accountNo"
                  label="账户编号"
                  prop="accountNo"
                >
                  <a-input
                    type="number"
                    style="width: 317px"
                    :disabled="true"
                    v-model="addform.accountNo"
                    placeholder="请输入账户编号"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  ref="applyAmount"
                  label="申请金额"
                  prop="applyAmount"
                >
                  <a-input
                    type="number"
                    :disabled="disabled"
                    v-model="addform.applyAmount"
                    placeholder="请输入申请金额"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="actualRefundAmount"
                  label="实退金额"
                  prop="actualRefundAmount"
                >
                  <a-input
                    type="number"
                    style="width: 317px"
                    v-model="addform.actualRefundAmount"
                    placeholder="请输入账户编号"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12"> </a-col>
            </a-row>

            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  ref="comments"
                  label="审核意见"
                  prop="comments"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 20 }"
                >
                  <a-input
                    :disabled="disabled"
                    v-model="addform.comments"
                    placeholder="请输入审核意见"
                    type="textarea"
                    style="height: 80px"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>


      </a-modal>

      <a-modal
          v-model="addvisible2"
          class="modal"
          width="900px"
          :maskClosable="false"
          @ok="handleOk"
          @cancel="handleCancelGood(false)"
        >
          <div class="tip-icon">客户会员权益详情:</div>
          <!-- 展示内容 -->
          <a-divider />
          <div class="base-content">
            <!-- 表格 -->
            <a-table
            style="overflow-x: auto;"
              :columns="columns2"
              :row-key="(record) => record.id"
              :data-source="userList"
              bordered
              :pagination="false"
              size="small"
          
              :scroll="{ x: 800, y: 'calc(100vh - 300px)' }"
              class="table"
            >
              <span slot="index" slot-scope="text, record, index">
                {{ index + (pageNum - 1) * pageSize + 1 }}
              </span>
              <span slot="expiryDate" slot-scope="text, record">
                {{ record.expiryDate | DictionaryFilter("GOOD_VALIDITY") }}
              </span>
            </a-table>
            <!-- 分页 -->
            <div class="base-pagination">
              <div class="total-view">
                共{{ totalRows1 }}条数据，第{{ pageNum1 }}/{{ totalPages1 }}页
              </div>
              <div class="pagination-buttons">
                <a-pagination
                  v-model="pageNum1"
                  :total="totalRows1"
                  :defaultPageSize="pageSize1"
                  show-less-items
                  @change="changePageFnGood($event)"
                />
              </div>
            </div>
          </div>
          <template #footer>
            <!-- 底部按钮区域 -->
            <a-button class="btaction" @click="addinputok" :loading="disabled"
              >确 定</a-button
            >
          </template>
        </a-modal>
    </div>
  </div>
</template>
  <script>
import {
  Queryrefund,
  queryId,
  shenhe,
  accountQueryAll,
  Refundapply,
  Querycmrel,
  Querycmequ,
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "userManagement",

  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      custName: "",
      equityName: "",
      //表格
      tableData: [],
      Title: "",
      //新增弹出框
      visible: false,
      // 表单验证
      rules: {
        comments: [
          {
            required: true,
            max: 100,
            message: "备注长度不能超过100",
          },
        ],
        reviewStatus: [
          {
            required: true,
            message: "请选择审核状态",
            trigger: "change",
          },
        ],
        actualRefundAmount: [
          {
            required: true,
            message: "请输入实退金额",
            trigger: "blur",
          },
        ],
        reviewStatus: [
          {
            required: true,
            message: "请选择审核结果",
            trigger: "change",
          },
        ],
      },
      // 新增表单校验
      addrules: {
        accountName: [
          {
            required: true,
            message: "请选择账户",
            trigger: "blur",
          },
        ],
        accountAmount: [
          {
            message: "请选择账户",
            trigger: "blur",
          },
        ],
        accountNo: [
          {
            message: "请选择账户",
            trigger: "blur",
          },
        ],
        applyAmount: [
          {
            required: true,
            message: "请输入申请金额",
            trigger: "blur",
          },
        ],
        comments: [
          {
            required: true,
            message: "请输入审核意见",
            trigger: "blur",
          },
        ],
        actualRefundAmount: [
          {
            required: true,
            message: "请输入实退金额",
            trigger: "blur",
          },
        ],
      },
      form: {
        accountAmount: "",
        accountName: "",
        accountNo: "",
        actualRefundAmount: "",
        comments: "",
        reviewStatus: undefined,
      },
      //审核选择时校验bug
      reviewStatuss: undefined,
      loading: false,
      Tableloading: false,
      disabled: false,
      //数列
      columns: [
      {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 50,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
      
      {
        
        title: "业务流水号",
        dataIndex: "busSerialNum",
        key: "busSerialNum",
        align: "center",
        ellipsis: true,
        width: 100,
        scopedSlots: { customRender: "busSerialNum" },
      },
      {
        
          title: "客户姓名",
          dataIndex: "custName",
          key: "custName",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "custName" },
        },
        {
          title: "购买日期",
          dataIndex: "createTime",
          key: "createTime",
          align: "center",
          ellipsis: true,
          width: 180,
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "客户手机号",
          dataIndex: "phoneNo",
          key: "phoneNo",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "phoneNo" },
        },

        {
          title: "权益名称",
          dataIndex: "equityName",
          key: "equityName",
          align: "center",
          ellipsis: true,
          width: 90,
          scopedSlots: { customRender: "equityName" },
        },

        {
          title: "会员权益说明",
          dataIndex: "remark",
          key: " remark",
          align: "center",
          width: 200,
          scopedSlots: {
            customRender: "o remark",
          },
        },
        {
          title: "面值(元)",
          dataIndex: "faceValue",
          key: "faceValue",
          align: "center",
          ellipsis: true,
          width: 90,
          scopedSlots: { customRender: "faceValue" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,
      tiukuanStatus: [], //退款审核
      tiufeiStatus: [], //退费
      formLayout: "horizontal",
      addvisible: false,
      userList: [],
      addform: {
        accountAmount: "",
        accountName: undefined,
        applyAmount: "",
        accountNo: "",
        comments: "",
        actualRefundAmount: "",
        openId: "",
      },
      addvisible2: false,
      columns2: [
      {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 40,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          
          title: "账户编号",
          align: "center",
          dataIndex: "accountNo",
          width: 130,
          key: "accountNo",
          ellipsis: true,
          scopedSlots: { customRender: "accountNo" },
        },
       
        {
          title: "次数",
          align: "center",
          dataIndex: "count",
          width: 50,
          key: "count",
          ellipsis: true,
          scopedSlots: { customRender: "count" },
        },
        {
          title: "截止日期",
          align: "center",
          dataIndex: "deadlineDate",
          width: 180,
          key: "deadlineDate",
          ellipsis: true,
          scopedSlots: { customRender: "deadlineDate" },
        },
        {
          title: "权益商品名称",
          align: "center",
          dataIndex: "goodName",
          width: 130,
          key: "goodName",
          ellipsis: true,
          scopedSlots: { customRender: "goodName" },
        },
        {
          title: "商品编号",
          align: "center",
          dataIndex: "goodCode",
          width: 100,
          key: "goodCode",
          ellipsis: true,
          scopedSlots: { customRender: "goodCode" },
        },
        {
          title: "商品类型",
          align: "center",
          dataIndex: "equType",
          width: 80,
          key: "equType",
          ellipsis: true,
          scopedSlots: { customRender: "equType" },
        },
        
        
       
        {
          title: "商品单价",
          align: "center",
          dataIndex: "goodPrice",
          width: 100,
          key: "goodPrice",
          ellipsis: true,
          scopedSlots: { customRender: "goodPrice" },
        },
        {
          title: "商品说明",
          align: "center",
          dataIndex: "goodRemark",
          width: 100,
          key: "goodRemark",
          ellipsis: true,
          scopedSlots: { customRender: "goodRemark" },
        },
        {
          title: "有效期",
          align: "center",
          dataIndex: "expiryDate",
          width: 80,
          key: "expiryDate",
          ellipsis: true,
          scopedSlots: { customRender: "expiryDate" },
        },
        {
          title: "状态",
          align: "center",
          dataIndex: "status",
          width: 100,
          key: "status",
          ellipsis: true,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "使用次数",
          align: "center",
          dataIndex: "usedCount",
          width: 100,
          key: "usedCount",
          ellipsis: true,
          scopedSlots: { customRender: "usedCount" },
        },


      ],
      selectedRowKeys: [],
      selectedRows: [],
      addinputform: {},
      // add点击input弹出页面分页
      pageNum1: 1,
      pageSize1: 10,
      totalRows1: 0,
      totalPages1: 0,
      id:"",
      custId:""
    };
  },
  activated() {
    DictionaryService.getAllNeedDic([
      "REFUND_APPLY_STATUS",
      "REFUND_STATUS",
    ]).then((res) => {
      this.tiukuanStatus = DictionaryService.getOptions("REFUND_APPLY_STATUS");
      this.tiufeiStatus = DictionaryService.getOptions("REFUND_STATUS");

      this.searchList();
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
    rowSelection() {
      const { selectedRowKeys, selectedRows } = this;
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
        //不可点击事件
        getCheckboxProps: (record) => ({
          props: {
            // disabled: record.sta === 2,
          },
        }),
      };
    },
  },
  methods: {
    //分页
    changePageFn(event) {
      this.pageNum = event;
      this.searchList();
    },
    //列表查询
    searchList(sum = 2) {
      //this.id= this.id;
      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          custName: this.custName,
          equityName: this.equityName,
        },
      };
      Querycmrel(obj).then(
        (res) => {
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {}
      );
    },
    //新增弹窗
    examine(value) {
      this.id = value.id;
      this.disabled = false;
      this.visible = true;

      this.Title = "审核";
      queryId({ id: this.id }).then((res) => {
        this.form.accountName = res.content.accountName;
        this.form.accountNo = res.content.accountNo;
        this.form.id = res.content.id;
        this.form.comments = res.content.comments;
        this.form.applyAmount = res.content.applyAmount;
        this.form.actualRefundAmount = res.content.actualRefundAmount;
      });
    },
    getId() {
      queryId({ id: this.id }).then((res) => {
        this.form = res.content;
      });
    },
    //删除
    handleDelete(text) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          dictDele({ id: text.id }).then(
            (res) => {
              this.$message.success("删除成功");
              this.searchList();
            },
            (err) => {}
          );
        },
        onCancel: () => {},
      });
    },
    // 关闭箭头的回调
    handleCancel(e) {
      this.$refs["ruleForm"].resetFields();
      this.form.remark = "";
    },
    // 确定
    handleOk(e) {
      Querycmequ({
        content: { cmrId: e.id, custId: e.custId },
        pageParam: {
          pageNum: 1,
          pageSize: 10,
          orderBy: "",
        },
      }).then((res) => {
        this.loading = false;
        this.visible = false;
        this.searchList();
        this.$message.success("修改成功");
        this.$refs.ruleForm.resetFields();
      });
    },
    // 新增页面
    showModal() {
      this.addvisible = true;
      let obj = {
        pageParam: {
          pageNum: "",
          pageSize: "",
          orderBy: "",
        },
        content: {
          accountName: "",
          accountNo: "",
        },
      };
      accountQueryAll(obj).then((res) => {
        this.userList = res.content.rows;
        this.totalRows1 = res.content.page.totalRows;
      });
    },
    // 新增页面确定
    addhandleOk() {
      this.$refs.addruleForm.validate((valid) => {
        if (valid) {
          if (
            this.addform.accountAmount == null ||
            this.addform.accountNo == null
          ) {
            this.$message.info("账户信息错误");
          } else {
            Refundapply(this.addform).then((res) => {
              this.$message.info("新增退款申请成功");
              this.addvisible = false;
              this.searchList();
            });
            this.$refs.addruleForm.resetFields();
          }
        } else {
          return false;
        }
      });
    },
    //选取姓名的信息变化
    handleChange(value) {
      this.addform.accountName = value.accountName;
      this.addform.accountNo = value.accountNo;
      this.addform.accountAmount = value.accountAmount;
      this.addform.openId = value.openid;
    },

    // 新增input点击事件
    addinput(e) {
      window.sessionStorage.setItem(
              "equitydet",
              JSON.stringify(e)
            );
      this.$router.push({
        path: "/home/customer/register/equity-det",
        query: { cmrId: e.id, custId: e.custId },
      });

    },

    // 新增input弹出界面确定按钮
    addinputok() {
         this.addvisible2 = false;
    },
    // 新增input弹出界面翻页事件
    changePageFnGood(event) {
      this.pageNum1 = event;
      let obj = {
        pageParam: {
          pageNum: event,
          pageSize: 10,
          orderBy: "",
        },
        content: {
            cmrId: this.id,
            custId: this.custId,
        },
      };
      accountQueryAll(obj).then((res) => {
        this.userList = res.content.rows;
        this.totalRows1 = res.content.page.totalRows;
      });
      this.querygoodList();
    },
  },
};
</script>
  <style lang="less" scoped="scoped">
.bbbbtttt {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}
.fotersa {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-left: 10px;
  }
  .bttwo {
    margin-left: 10px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }

  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}
/deep/ .ant-table-body {
  max-height: 487px;
  overflow: auto;
  margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}

.add-mess {
  width: 100%;
  //overflow: auto;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 110px;
  }
  /* /deep/ .ant-form-item-control {
      width: 350px;
    } */
}
/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 245px;
}
.oper {
  // flex: 1;
  width: 200px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 76px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 72px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 68px;
}
/deep/ .ant-input-affix-wrapper {
  width: 160px;
}
/deep/ .ant-col-18 {
  width: 65%;
}
/deep/ .ant-col-12 {
  width: 45%;
}
/deep/.ant-col-20 {
  width: 82%;
}
/* /deep/.ant-select-selection--single {
    width: 160px;
  } */
</style>
  